/**
 * PRD-34 FR-20 — after this many wrong-password answers in one tab, the login
 * page points at "restablecer contraseña". A hint, never a lock: the lock is
 * the server's rate limit (`apps/backend/api/rate_limit.py`).
 */
export const LOGIN_RESET_HINT_AFTER_ATTEMPTS = 3

/** sessionStorage key for that count, so a reload does not reset it. */
export const LOGIN_FAILED_ATTEMPTS_KEY = "platonica_login_failed_attempts"

/**
 * PRD-34 FR-21 — where a dead session lands. The flag only switches on a
 * notice on /login; it is never a redirect target (no `?next=`).
 */
export const SESSION_EXPIRED_PARAM = "sesion"
export const SESSION_EXPIRED_VALUE = "expirada"
export const SESSION_EXPIRED_LOGIN_URL = `/login?${SESSION_EXPIRED_PARAM}=${SESSION_EXPIRED_VALUE}`
